import React from 'react';
import PropTypes from 'prop-types';

import { transformMarkupToReactElement } from '../util/markupTransformer';


function StoryCheckerDetailHighlightContent(props) {
  const { styles, markup, accountName = '', profileName = '' } = props;
  const highlightProps = { styles, accountName, profileName };
  const children = transformMarkupToReactElement(markup, highlightProps);

  return (<div className={styles.detailHighlightedContent}>{children}</div>);
}

StoryCheckerDetailHighlightContent.propTypes = {
  styles: PropTypes.object,
  markup: PropTypes.string.isRequired,
  accountName: PropTypes.string,
  profileName: PropTypes.string,
};


export default StoryCheckerDetailHighlightContent;
